import { put, takeLatest } from "redux-saga/effects";
import AxiosCustom from "common/components/apiConfig";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "common/method/handleNotificationAlert";

export const actionTypes = {
  SelectPledge_spread: "SelectPledge_spread [Action]",
  SelectPledge_spreadLoading: "SelectPledge_spreadLoading [Action]",
  SelectPledge_spreadAsync: "SelectPledge_spreadAsync [Action]",
};
const inistiaState = {
  data: [],
  loading: false,
};

export const Select_Pledge_spread_reducer = (
  state = inistiaState,
  { type, payload }
) => {
  switch (type) {
    case actionTypes.SelectPledge_spread:
      return {
        ...state,
        data: payload,
      };
    case actionTypes.SelectPledge_spreadLoading:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  yield put({ type: actionTypes.SelectPledge_spreadLoading, payload: true });

  let config = {
    url: "select_request",
  };

  let data = {
    table: "pledge",
    method_type: "pledge_spread",
    data: payload?.data ? payload.data : {},
  };

  try {
    let res = yield AxiosCustom(config, data);
    let isOk = handleNotificationAlertTrySelect(res);
    if (!isOk) {
      return;
    }

    yield put({
      type: actionTypes.SelectPledge_spread,
      payload: res?.data?.response?.data,
    });
  } catch {
    handleNotificationAlertCatch();
  } finally {
    yield put({
      type: actionTypes.SelectPledge_spreadLoading,
      payload: false,
    });
  }
}

export function* selectPledgeSpread() {
  yield takeLatest(actionTypes.SelectPledge_spreadAsync, handleWorker);
}
